var module = angular.module('octopusApp.infrastructure');

module.factory('pageTitle', function($rootScope) {
  return function(title) {
    $rootScope.pageTitle = title;
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/page_title.js
// module id = 703
// module chunks = 1